<script setup>
import {ref, onMounted, onBeforeUnmount, computed, nextTick} from 'vue'
import {Head} from "@inertiajs/vue3";

const props = defineProps({
    messages: Array,
    showLang: Boolean,
    delay: {
        type: String,
        default: '0s'
    },
    changesTitle: Boolean
})
const currentIndex = ref(0)
const isAnimating = ref(false)

const lineHeightPx = 28
const sliderStyle = computed(() => ({
  transform: `translateY(-${currentIndex.value * lineHeightPx}px)`,
  transition: 'transform 0.6s ease-in-out',
  transitionDelay: props.delay
}))

const loaded = ref(false);
let interval = null
onMounted(() => {
    nextTick().then(() => loaded.value = true);
    interval = setInterval(() => {
        isAnimating.value = true
        currentIndex.value = (currentIndex.value + 1) % props.messages.length
        setTimeout(() => { isAnimating.value = false }, 400)
    }, 4000)
})

onBeforeUnmount(() => {
    clearInterval(interval)
})
</script>

<template>
  <Head v-if="changesTitle" :title="messages[currentIndex].val"></Head>
  <div v-if="loaded" class="overflow-hidden text-nowrap relative text-ellipsis" :class="showLang?'-ml-12':''" style="height: 28px;">
    <div class="absolute top-0 left-0 w-full z-0" :style="sliderStyle">
      <div style="display: flex; flex-direction: column;">
        <div
          v-for="(msg, index) in messages"
          :key="index"
          class="min-h-[28px] flex items-center !transition-opacity"
          :class="index === currentIndex ? 'opacity-100':'opacity-20'"
        >
         <div v-if="showLang" class="font-sans border border-blue-500 text-roori-blue font-bold pt-[1px] dark:border-white dark:text-white px-2 rounded mr-4 text-xs h-[20px] dark:opacity-70">{{msg.lang}}</div> {{ msg.val }}
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
</style>
